import type { MiddlePanelTab } from '@/features/project/context/DesktopLayoutContext';

/**
 * The design page URL the rest of the app navigates with: the tab is always
 * explicit, `angleId` selects a secondary view, and the arrival token `n`
 * (the record arrived at) makes a repeat navigation onto the page already
 * shown re-apply the tab and scroll, exactly like the render-complete toast.
 */
export function designPath(
  buildingId: string,
  designId: string,
  tab: MiddlePanelTab,
  options: { angleId?: string | null; arrival?: string | null } = {}
): string {
  const query = new URLSearchParams({ tab });
  if (options.angleId) query.set('angleId', options.angleId);
  if (options.arrival) query.set('n', options.arrival);
  return `/project/${buildingId}/concept/${designId}?${query.toString()}`;
}
